<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-tabs [(ttSelectedId)]="setting.bg_productlinkschange_function" (ttSelectedIdChange)="onTabChange()">
            <tt-tab ttId="ADD" ttLabel="bg_productlinkschange_function_add"></tt-tab>
            <tt-tab ttId="REMOVE" ttLabel="bg_productlinkschange_function_remove"></tt-tab>
        </tt-tabs>

        <form class="form-horizontal sp-0" name="formProductLinksChange" novalidate (ngSubmit)="searchItems()" method="get" role="form" [hidden]="setting.bg_productlinkschange_function !== 'ADD'">
            <tt-input ttLabel="searchtext" [(ttModel)]="setting.searchtext" (ttModelChange)="onChanged($event, 'searchtext')" [ttButtons]="searchTextButtons"></tt-input>
        </form>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" ttCheckboxSelection [(ttData)]="itemsListChanges" ttGoto="false" ttButtonsPosition="left"></tt-list>

    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button-save ttText="productlinkschange_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
